
import {useStore} from "@/store";
import checkPositionCont from './checkPositionCont.vue';
import {defineComponent, reactive, ComputedRef, computed, watch} from "vue";

interface State {
    tocOnlyShowFlaw: boolean;
    showChildrenStatus: boolean;
}
export default defineComponent({
    name: 'checkPosition',
    props: {
        carPositionRenderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        carPositionRenderKey: {
            type: String,
            default: ''
        }
    },
    setup() {
        let state: State = reactive({
            tocOnlyShowFlaw: false,
            showChildrenStatus: false
        }); 
        let store = useStore();
        let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
        watch(tocOnlyShowFlawS, (data: any) => {
            // console.log('checkPosition:tocOnlyShowFlaw:', data);
            state.tocOnlyShowFlaw = data;
        }, {immediate: true})
        function changeChildrenShow() {
            state.showChildrenStatus = !state.showChildrenStatus;
        }
        return {
            state,
            changeChildrenShow
        }
    },
    components: {
        checkPositionCont
    }
})
